import React from 'react';
import { IconButton, TableRow, TableCell } from '@material-ui/core';
import { FormikNumericFormat } from '@klp/formgenerator/components/FormikNumericFormat';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { makeStyles } from '@material-ui/core';
import {
    handleFormikNumericFieldBlur,
    handleFormikNumericFieldChange,
} from '@forvalter/utils';
import { KostnadstypeDropdown } from './KostnadstypeDropdown';
import type { Kostnadslinje } from '@klp/prosjekt/services/types';
import { Amount } from '@klp/design/Amount';

const useStyles = makeStyles(() => ({
    tableRow: {},
}));

type KostnadskalkyleRowProps = {
    row: Kostnadslinje;
    index: number;
    isReadOnly?: boolean;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    remove: () => void;
};

const calculateKostnad = (enhet: number, prisPerEnhet: number) =>
    enhet * prisPerEnhet;

export const KostnadskalkyleRow = ({
    row,
    index,
    isReadOnly,
    handleChange,
    remove,
}: KostnadskalkyleRowProps) => {
    const classes = useStyles();

    const key = `kostnadslinjer.${index}`;
    const kostnad = calculateKostnad(row.antallEnhet, row.prisPrEnhet);

    return (
        <TableRow key={key} className={classes.tableRow}>
            <TableCell>
                <KostnadstypeDropdown
                    fieldName={`${key}.kostnadstype`}
                    rowKey={key}
                    isReadOnly={isReadOnly}
                />
            </TableCell>

            <TableCell>
                <FormikNumericFormat
                    id={`${key}.antallEnhet`}
                    disabled={isReadOnly}
                    variant="outlined"
                    decimalScale={0}
                    align="right"
                    onChange={(e) => {
                        handleFormikNumericFieldChange(
                            handleChange,
                            e,
                            `${key}.antallEnhet`,
                        );
                    }}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                        handleFormikNumericFieldBlur(e, handleChange);
                    }}
                />
            </TableCell>

            <TableCell>
                <FormikNumericFormat
                    id={`${key}.prisPrEnhet`}
                    disabled={isReadOnly}
                    variant="outlined"
                    decimalScale={2}
                    align="right"
                    onChange={(e) => {
                        handleFormikNumericFieldChange(
                            handleChange,
                            e,
                            `${key}.prisPrEnhet`,
                        );
                    }}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                        handleFormikNumericFieldBlur(e, handleChange);
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <Amount value={kostnad} round={false} />
            </TableCell>

            <TableCell>
                <FormikNumericFormat
                    id={`${key}.andelKostnadsforing`}
                    disabled={isReadOnly}
                    variant="outlined"
                    decimalScale={2}
                    align="right"
                    isAllowed={(v) => {
                        const { floatValue } = v;
                        return (
                            floatValue === undefined ||
                            (floatValue >= 0 && floatValue <= 100)
                        );
                    }}
                    onChange={(e) =>
                        handleFormikNumericFieldChange(
                            handleChange,
                            e,
                            `${key}.andelKostnadsforing`,
                        )
                    }
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                        handleFormikNumericFieldBlur(e, handleChange);
                    }}
                />
            </TableCell>

            <TableCell>
                {!isReadOnly && (
                    <IconButton onClick={() => remove()} color="primary">
                        <Illustration
                            icon={IconName.DELETE}
                            klpPalette="primary"
                            klpColor="main"
                        />
                    </IconButton>
                )}
            </TableCell>
        </TableRow>
    );
};
